import React from 'react';
import { Bot, Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black py-12 border-t border-white/10" data-id="element-79">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-80">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12" data-id="element-81">
          <div className="text-center md:text-left" data-id="element-82">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-4" data-id="element-83">
              <Bot className="w-8 h-8 text-cyan-400" data-id="element-84" />
              <span className="font-display font-bold text-2xl tracking-tight text-white" data-id="element-85">
                SABER-DIGITAL™
              </span>
            </div>
            <p className="text-gray-400 max-w-md" data-id="element-86">
              El sistema de aprendizaje e implementación de IA N°1 para el mundo
              hispanohablante. Porque dominar la Inteligencia Artificial no
              debería costarte años de prueba y error.
            </p>
          </div>

          <div className="flex flex-col gap-4 text-gray-400" data-id="element-87">
            <a href="mailto:soportesaberdigital0@gmail.com" className="flex items-center gap-3 hover:text-cyan-400 transition-colors" data-id="element-88">
              <Mail className="w-5 h-5" data-id="element-89" /> soportesaberdigital0@gmail.com
            </a>
            <a href="#" className="flex items-center gap-3 hover:text-cyan-400 transition-colors" data-id="element-90">
              <Instagram className="w-5 h-5" data-id="element-91" /> @saberdigital
            </a>
            <a href="#" className="flex items-center gap-3 hover:text-cyan-400 transition-colors" data-id="element-92">
              <Globe className="w-5 h-5" data-id="element-93" /> www.soportesaberdigital.com
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-94">
          <p data-id="element-95">© SABER-DIGITAL™ 2026 — Todos los derechos reservados.</p>
          <p className="italic" data-id="element-96">🤖 "El próximo lunes puede ser diferente."</p>
        </div>
      </div>
    </footer>;
}